<template>
  <div v-if="$store.getters['global/isModalShown'] === true">
    <transition name="modal" >
      <div class="modal-mask" v-on:click.self="closeModal">
        <div class="modal-wrapper ">
          <component :is="modalComponent" :close-modal=closeModal
            :action=action :room=room >
          </component>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import BlockRoomModal from '@/layout/modals/BlockRoomModal.vue'
import CloseRoomModal from '@/layout/modals/CloseRoomModal.vue'
import ClosedRoomModal from '@/layout/modals/ClosedRoomModal.vue'
import ErrorMsgModal from '@/layout/modals/ErrorMsgModal.vue'
import LogoutModal from '@/layout/modals/LogoutModal.vue'
import SendLocationsModal from '@/layout/modals/SendLocationsModal.vue'
import TransferRoomModal from '@/layout/modals/TransferRoomModal.vue'
import TransferredRoomModal from '@/layout/modals/TransferredRoomModal.vue'
import ZencallModal from '@/layout/modals/ZencallModal.vue'

export default {
  name: 'Modal',
  components: {
    ApplePayModal: () => import(
      /* webpackChunkName: "custom-applepay-modal" */
      /* webpackPreload: -1 */
      `@/custom/${process.env.VUE_APP_CUSTOM}/ApplePay/ApplePayModal.vue`),
    SendItemsListModal: () => import(
      /* webpackChunkName: "custom-senditemslist-modal" */
      /* webpackPreload: -1 */
      `@/custom/${process.env.VUE_APP_CUSTOM}/SendItemsList/SendItemsListModal.vue`),
    BlockRoomModal,
    CloseRoomModal,
    ClosedRoomModal,
    ErrorMsgModal,
    LogoutModal,
    SendLocationsModal,
    TransferRoomModal,
    ZencallModal
  },
  data () {
    return {
      modalComponent: null
    }
  },
  computed: {
    action () {
      return this.$store.getters['global/getAction']
    },
    room () {
      return this.$store.getters['rooms/getRoom']
    }
  },
  methods: {
    closeModal () {
      this.$store.commit('global/resetAction')
      this.$store.commit('global/hideModal')
    }
  },
  watch: {
    action (newValue) {
      if (newValue === 'block-room') {
        this.modalComponent = BlockRoomModal
      } else if (newValue === 'close-room') {
        this.modalComponent = CloseRoomModal
      } else if (newValue === 'closed-room') {
        this.modalComponent = ClosedRoomModal
      } else if (newValue === 'error-msg') {
        this.modalComponent = ErrorMsgModal
      } else if (newValue === 'send-address') {
        this.modalComponent = SendLocationsModal
      } else if (newValue === 'logout') {
        this.modalComponent = LogoutModal
      } else if (newValue === 'transfer') {
        this.modalComponent = TransferRoomModal
      } else if (newValue === 'transferred') {
        this.modalComponent = TransferredRoomModal
      } else if (newValue === 'zencall') {
        this.modalComponent = ZencallModal
      } else if (newValue === 'apple-pay') {
        // dynamic import
        this.modalComponent = this.$options.components.ApplePayModal
      } else if (newValue === 'send-items-list') {
        // dynamic import
        this.modalComponent = this.$options.components.SendItemsListModal
      }
    }
  }
}
</script>

<style lang="scss">
body.modal-open {
  overflow-y: hidden;
}
</style>

<style lang="scss" scoped>

div.channel-logo img {
  width: 32px;
}

div.form-control {
  height: 10rem;
  overflow: auto;
  white-space: pre-line;
}

.modal-mask {
  position: fixed;
  z-index: 19998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: block;
  max-height: 100%;
  overflow-y: auto;
  position: fixed;
  width: 100%;
}

.modal-container {
  background-color: #fff;
  border-radius: .3rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  margin: 1.75rem auto;
  max-height: 100%;
  max-width: 800px;
  min-width: 300px;
  padding: 20px 30px;
  transition: all .3s ease;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>
